<template>
  <div class="common_contentBox">
    <div class="common_search">
      <el-row>
        <!-- 报备编码 -->
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <span class="labelCopy">{{ $t('industryReport.hybblb.cxtj.bbbh') }}：</span>
          <div class="contentCopy">
            <el-input v-model="form.activityCode" :placeholder="$t('general.pec')" />
          </div>
        </el-col>
        <!-- 活动名称 -->
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <span class="labelCopy">{{ $t('industryReport.hdxx.hdmc') }}：</span>

          <div class="contentCopy">
            <el-input v-model="form.activityName" :placeholder="$t('general.pec')" />
          </div>
        </el-col>
        <!-- 报备人 -->

        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <span class="labelCopy">{{ $t('industryReport.hybblb.cxtj.bbr') }}：</span>

          <div class="contentCopy">
            <el-input v-model="form.applyUserNameOrId" :placeholder="$t('general.pec')" />
          </div>
        </el-col>
        <!-- 行业 -->
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <span class="labelCopy">{{ $t('industryReport.hybblb.cxtj.hy') }}：</span>
          <div class="contentCopy">
            <el-select v-model="form.targetIndustry" :placeholder="$t('general.ps')" clearable>
              <el-option v-for="item in industryList" :key="item.fieldKey" :label="item.fieldValue"
                         :value="item.fieldKey"
              />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" />
        <div class="btnBar">
          <el-button @click="onreset" plain>{{ $t('btn.Reset') }}</el-button>
          <el-button @click="searchBtn" type="primary">{{ $t('btn.Search') }}</el-button>
        </div>
      </el-row>
    </div>
    <div class="common_btnBar">
      <el-button type="primary" @click="biJump">{{ $t('eventList.BIFind') }}</el-button>
    </div>
    <commonTable ref="reportListTable" />
    <el-dialog :visible.sync="dialogVisible" width="600px" class="activityDialog">
      <template #title>
        <div class="dialog-header">
          {{ $t('industryReport.zdchqy.name') }}
        </div>
      </template>
      <commonTable ref="activityDialogTable" />
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" type="info">
          {{ $t('btn.Close') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import commonTable from '@/components/commonTable';
import { TableRow, TableColumns } from '@/utils/tableOptions.js';
import { newApplicationFormApi } from '../newApplicationForm/service';
import { formatTargetObjectDisplay } from '../newApplicationForm/mixins/targetObjectMixin';
export default {
  name: 'IndustryActivitySummary',
  data () {
    return {
      dialogVisible: false,
      form: {
        activityCode: '', // 报备编码
        activityName: '', // 活动名称
        applyUserNameOrId: '', // 报备人
        targetIndustry: '' // 行业

      },
      industryList: []
    };
  },
  components: {
    commonTable
  },
  mounted () {
    this.loadTable();
    this.getActivityList();
  },
  methods: {
    getActivityList () {
      let params = [
        'report_industry' // 面向行业
      ];
      newApplicationFormApi.getActivityList(params).then(res => {
        if (res.status === '200') {
          let { data } = res;
          this.industryList = data.report_industry;
        }
      });
    },
    biJump () {
      window.open('http://ruijiebi.ruijie.com.cn/webroot/decision?rjl=oa');
    },
    check (row) {
      this.dialogVisible = true;
      this.loadTableDialog(row.activityCode);
    },
/**
* 重置表单并触发搜索按钮点击事件
*/
    onreset () {
      this.form = {
        activityCode: '', // 报备编码
        activityName: '', // 活动名称
        applyUserNameOrId: '', // 报备人
        targetIndustry: '' // 行业
      };
      this.searchBtn();
    },
    // 搜索事件
    searchBtn () {
      this.$refs.reportListTable.pageData.pageNum = 1;
      this.$refs.reportListTable.getTableData({ url: '/activity/getIndustryHeadquartersActivitySummary', params: this.form });
    },
    loadTable () {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._title(this.$t('industryReport.hybblb.cxtj.bbbh'))
          ._data('activityCode')
          ._width('150')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
                return row.activityCode ? row.activityCode : '-';
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('industryReport.hdxx.hdmc'))
          ._data('activityName')
          ._width('200')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
                return row.activityName ? row.activityName : '-';
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('industryReport.hybblb.cxtj.hy'))

          ._data('targetIndustry')
          ._width('100')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
                return row.targetIndustry ? row.targetIndustry : '-';
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('industryReport.hdxx.yjjbzq'))
          ._data('expectPeriod')
          ._width('300')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
                return row.expectPeriod ? row.expectPeriod : '-';
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('industryReport.hdxx.zymbdx'))

          ._data('targetObject')
          ._width('120')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
                if (!row.targetObject) return '-';
                return formatTargetObjectDisplay(row.targetObject, row.targetObjectOther, this.$t.bind(this));
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('industryReport.hdxx.jbcs'))
          ._data('city')
          ._width('100')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
                return row.city ? row.city : '-';
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('industryReport.hybblb.list.nyqzrs'))
          ._data('inviterNum')
          ._width('150')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
                return row.inviterNum ? row.inviterNum : '-';
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('industryReport.hybblb.list.zdldqy'))
          ._width('120')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              if (!row.activityCode) {
                return '-';
              }
              return (
                <div>
                  <el-button type="text" onClick={() => { this.check(row); }}>{ this.$t('btn.View') }</el-button>
                </div>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('industryReport.hdxx.hdgjb'))
          ._data('activityToolkit')
          ._offOverFlow(true)
          ._width('200')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
                if (!row.activityToolkit) {
                  return '-';
                }
                return (
                  <span class="activity-toolkit" onClick={() => {
                    if (row.activityToolkit) {
                      window.open(row.activityToolkit);
                    }
                  }}>{row[column.property]}</span>
                );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('industryReport.hybblb.list.hybbr'))
          ._data('salerName')

          ._width('100')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
                return row.salerName ? row.salerName : '-';
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('industryReport.hybblb.list.bbsj'))
          ._data('createTime')
          ._width('200')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
                return row.createTime ? row.createTime : '-';
            }
          })
      );
      let column = tableRow._cols();
      this.$nextTick(() => {
        this.$refs.reportListTable.setColumn(column, {
          page: true
        });
        this.$refs.reportListTable.loadTable({
          url: '/activity/getIndustryHeadquartersActivitySummary',
          listKey: 'resultList',
          params: {}
        });
      });
    },
    loadTableDialog (activityCode) {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._title(this.$t('industryReport.hybblb.cxtj.qymc'))
          ._data('regionName')
          ._width('200')
           ._align('center')
      );
      let column = tableRow._cols();
      this.$nextTick(() => {
        this.$refs.activityDialogTable.setColumn(column, {
          page: false
        });
        this.$refs.activityDialogTable.loadTable({
          url: '/activity/getIndustryHeadquartersActivitySummaryLandingArea',
          listKey: 'resultList',
          params: {
            activityCode
          }
        });
      });
    }
  }

};
</script>
<style scoped>
.dialog-header {
  text-align: center; /* 文字水平居中 */
  font-size: 18px;
    /* line-height: 16px; */
    color: #5B646E;
  width: 100%;
}
.activity-toolkit{
  color: #508DB4;
  cursor: pointer;
}
</style>
